export default "__VITE_ASSET__DvX1Opg2__"